export const ApiEndpoints = {
  userList: '/api/users/',
  userDetail: '/api/users/:id:/',
  userProfile: '/api/user-profiles/:id:/',
  userTravelProfile: '/api/user-travel-profiles/:id:/',
  userICal: '/api/roster/ical/?user__id=:id:',
  userICalItem: '/api/roster/ical/:id:/',

  activitiesList: '/api/activity/',
  activityExport: '/api/activity/activity_export_report',
  activity: '/api/activity/:id:/',
  activityReportingGroupsList: '/api/reporting-group/',
  activityReportingGroup: '/api/reporting-group/:id:/',
  activityTemplatesList: '/api/template/',
  activityTemplate: '/api/template/:id:/',
  activityTemplateClone: '/api/template/:id:/clone/',
  activityTemplateActivities: '/api/templates/:id:/activities/',
  activityBulkAddCompetencies: '/api/activity/:id:/add_competencies/',
  activityBulkRemoveCompetencies: '/api/activity/:id:/remove_competencies/',

  activityTypeList: '/api/activity-type/',
  activityType: '/api/activity-type/:id:/',

  activityRosterBuildersList: '/api/rosterbuilders/',
  activityRosterBuilder: '/api/rosterbuilders/:id:/',
  activityRosterBuilderActivities: '/api/rosterbuilders/:id:/activities/',

  competenciesList: '/api/competency/',
  competency: '/api/competency/:id:/',
  competencyTypeList: '/api/competency-type/',
  competencyType: '/api/competency-type/:id:/',

  competencyUnassignedUsers: '/api/users/',
  competencyAssignedUsers: '/api/users/',
  competencyBulkAddUsers: '/api/competency/:id:/add_users/',
  competencyBulkRemoveUsers: '/api/competency/:id:/remove_users/',

  competencyBulkAddActivities: '/api/competency/:id:/add_activities/',
  competencyBulkRemoveActivities: '/api/competency/:id:/remove_activities/',

  competencyValidation: '/api/competency/users_activities_check/',

  userCompetency: '/api/user-competency/:id:/',
  userCompetencyList: '/api/user-competency/',

  rosterList: '/api/roster/meta/',
  rosterDetail: '/api/roster/meta/:id:/',
  rosterVersionList: '/api/roster/version/',
  rosterVersionDetail: '/api/roster/version/:id:/',
  rosterVersionPublish: '/api/roster/version/:id:/publish/?from=:from:&to=:to:',
  rosterAssignmentList: '/api/roster/assignment/get_all/',
  rosterValidatorList: '/api/roster/validator/',
  rosterValidationList: '/api/roster/validation/?roster_id=:r_id:',
  rosterValidation: '/api/roster/validation/:id:/',
  rosterValidationTask: '/api/roster/validation_task/:id:/',
  rosterValidationTaskList: '/api/roster/validation_task/',
  rosterAssignmentBulkUpdate: '/api/roster/assignment/bulkUpdate/?version_id=:v:',

  travelModeList: '/api/travel/route/travel_modes/',
  travelLocationList: '/api/travel/location/',
  travelLocation: '/api/travel/location/:id:/',
  travelRouteTypeList: '/api/travel/route_type/',
  travelRouteType: '/api/travel/route_type/:id:/',
  travelRouteList: '/api/travel/route/',
  travelRoute: '/api/travel/route/:id:/',
  travelLegList: '/api/travel/leg/',
  travelLeg: '/api/travel/leg/:id:/',
  travelLinksList: '/api/travel/links/',
  travelLink: '/api/travel/links/:id:/',
  travelBookingList: '/api/travel/booking/',
  travelBooking: '/api/travel/booking/:id:/',
  travelBookingHistory: '/api/travel/booking/:id:/history/',
  travelBookingStatusList: '/api/travel/booking_status/',
  travelBookingBulkStatus: '/api/travel/booking/bulk_update_status/',
  travelItineraryList: '/api/travel/itinerary/',
  travelItinerary: '/api/travel/itinerary/:id:/',

  whoami: '/api/me/whoami/',
  tokenRefresh: '/api/token/refresh/',
  tokenAuth: '/api/token/auth/',
  tagThemeList: '/api/tag/theme/',
  tagCollectionList: '/api/tag/collection/',
  tagCollection: '/api/tag/collection/:id:/',
  tagValue: '/api/tag/value/',
  tagValueDetail: '/api/tag/value/:id:/',
  tagValueAddUsers: '/api/tag/value/:id:/add_users/',
  tagValueRemoveUsers: '/api/tag/value/:id:/remove_users/',
  tagObject: '/api/tag/object/:id:/',
  tagObjectList: '/api/tag/object/',
  tagObjectListShallow: '/api/tag/object/?shallow=true',
  tagObjectBulk: '/api/tag/object/bulk/',
  tagObjectBulkDelete: '/api/tag/object/bulk-delete/',

  groups: '/api/groups/',
  groupsUser: '/api/user-groups/',
  groupsAssignedUser: '/api/user-groups/?user=:id:',
  groupsAssignUser: '/api/user-groups/bulk_add/',
  groupsDeleteUser: '/api/user-groups/bulk_delete/',

  availabilityUserCycleList: '/api/availability/user-cycle/',
  availabilityUserCycleLayerList: '/api/availability/user-cycle/layer/',
  availabilityUserCycle: '/api/availability/user-cycle/:id:/',

  availabilityCycleList: '/api/availability/cycle/',
  availabilityCycle: '/api/availability/cycle/:id:/',
  availabilityCycleLegList: '/api/availability/cycle-leg/',
  availabilityCycleLeg: '/api/availability/cycle-leg/:id:/',

  availabilityLegList: '/api/availability/leg/',
  availabilityLeg: '/api/availability/leg/:id:/',
  availabilityLegTypeList: '/api/availability/leg-type/',
  availabilityLegType: '/api/availability/leg-type/:id:/',
  availabilityLeaveTypeList: '/api/availability/leave-type/',
  availabilityLeaveType: '/api/availability/leave-type/:id:/',
  availabilityLeaveStatusList: '/api/availability/leave-status/',
  availabilityLeaveStatus: '/api/availability/leave-status/:id:/',
  availabilityLeaveList: '/api/availability/user-leave/',
  availabilityLeave: '/api/availability/user-leave/:id:/',

  actionList: '/api/actions/action/',
  action: '/api/actions/action/:id:/',
  actionResolve: '/api/actions/action/:id:/resolve/',

  actionTypeList: '/api/actions/action-type/',
  actionType: '/api/actions/action-type/:id:/',
  actionStatusList: '/api/actions/status/',
  actionStatus: '/api/actions/status/:id:/',
  actionPriorityList: '/api/actions/priority/',
  actionPriority: '/api/actions/priority/:id:/',
  actionContextList: '/api/actions/context/',
  actionContext: '/api/actions/context/:id:/',

  notificationList: '/api/notification/',
  notification: '/api/notification/:id:/',
  notificationTypeList: '/api/notification/type/',
  notificationRuleList: '/api/notification/rule/',
  notificationRuleBulk: '/api/notification/rule/bulk_delete/',
  notificationRule: '/api/notification/rule/:id:/',
  notificationRunList: '/api/notification/run/?version_id=:v_id:',
  notificationRunBulk: '/api/notification/run/bulk_delete/?version_id=:v_id:',
  notificationRun: '/api/notification/run/:id:/?version_id=:v_id:',
  notificationTheme: '/api/notification/theme/',

  commentList: '/api/comments/comment/',
  comment: '/api/comments/comment/:id:/',
  commentThemeList: '/api/comments/theme/',
  commentTheme: '/api/comments/theme/:id:/',

  reportList: '/api/report/job_list/',
  manningReportList: '/api/report/manning_report/',
  objectHistoryList: '/api/audit/object-history/',
  objectHistoryThemesList: '/api/audit/themes/',

  reports: '/api/report/reports/',
  report: '/api/report/reports/:id:/',

  optimiserStatusSummary: '/api/optimiser-status/',
  optimiserStatusViolations: '/api/optimiser-status/violations/',
  optimiserStatusExport: '/api/optimiser-status/export/',
  optimiserBrokerHealth: '/api/optimiser-status/broker-health/',
  optimiserStatusPublishAttempts: '/api/optimiser-status/publish-attempts/',
  optimiserStatusRetry: '/api/optimiser-status/:id:/retry/',
  optimiserStatusAttemptRecords: '/api/optimiser-status/:id:/records/',
  optimiserRunStatus: '/api/optimiser-status/run-status/',
  optimiserStatusRunHistory: '/api/optimiser-status/run-history/',
  optimiserStatusWritebackHistory: '/api/optimiser-status/writeback-history/'
};

export default ApiEndpoints;
